import { ReactNode } from "react";
import { AppLayout } from "./AppLayout";
import { BreadcrumbItem } from "./Breadcrumb";
export function MailDetailLayout({
  embedded,
  children,
  topbarActions,
  breadcrumbs,
  mainClassName,
  logoIcon,
}: {
  embedded?: boolean;
  children: ReactNode;
  topbarActions?: ReactNode;
  breadcrumbs: BreadcrumbItem[];
  mainClassName?: string;
  logoIcon?: ReactNode;
}) {
  return embedded ? (
    <div className="mail-conversation">
      <div
        className="mail-detail-toolbar"
        role="toolbar"
        aria-label="Azioni del dettaglio"
      >
        {topbarActions}
      </div>
      {mainClassName === "mail-email-content" ? (
        <div className="mail-email-content">{children}</div>
      ) : (
        children
      )}
    </div>
  ) : (
    <AppLayout
      breadcrumbs={breadcrumbs}
      topbarActions={topbarActions}
      mainClassName={mainClassName}
      logoIcon={logoIcon}
    >
      {children}
    </AppLayout>
  );
}
